import React from 'react';
import { HistoryDataRes } from '../../types/res';
import { MemoryCardItem } from './MemoryCardItem';
import { Stack } from '@mui/material';

interface MemoryCardDataProps {
  historyData: HistoryDataRes[];
}

export const MemoryCardData: React.FC<MemoryCardDataProps> = ({ historyData }) => {
  return (
    <Stack paddingTop={2}>
      {historyData.map((item) => (
        <MemoryCardItem key={item.title} item={item} />
      ))}
    </Stack>
  );
};
